import { Host, h } from "@stencil/core";
import { INITIAL_LEVEL, getTreeItemLevelPart } from "../../utils";
const TREE_DROP_TAG_NAME = "ch-tree-view-drop";
export class ChTreeViewDrop {
    constructor() {
        this.dragState = "none";
        this.level = INITIAL_LEVEL;
        this.treeItemId = undefined;
        this.type = "before";
    }
    render() {
        const canShowLines = this.level !== INITIAL_LEVEL;
        const levelPart = getTreeItemLevelPart(this.level % 2 === 0);
        return (h(Host, { key: 'a088f6d074c094155150bffbf11e2e9704fbe550', class: {
                ["gx-" + levelPart]: canShowLines,
                [TREE_DROP_TAG_NAME + "--drag-enter"]: this.dragState === "enter"
            }, style: { "--level": `${this.level}` } }));
    }
    static get is() { return "ch-tree-view-drop"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["tree-view-drop.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tree-view-drop.css"]
        };
    }
    static get properties() {
        return {
            "dragState": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "DragState",
                    "resolved": "\"enter\" | \"none\" | \"start\"",
                    "references": {
                        "DragState": {
                            "location": "import",
                            "path": "../tree-view-item/tree-view-item",
                            "id": "src/components/tree-view/internal/tree-view-item/tree-view-item.tsx::DragState"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property lets you define the current state of the item when it's\nbeing dragged."
                },
                "attribute": "drag-state",
                "reflect": false,
                "defaultValue": "\"none\""
            },
            "level": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Level in the tree at which the item is placed."
                },
                "attribute": "level",
                "reflect": false,
                "defaultValue": "INITIAL_LEVEL"
            },
            "treeItemId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the id of the tree item that this element controls."
                },
                "attribute": "tree-item-id",
                "reflect": false
            },
            "type": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "Exclude<TreeViewDropType, \"above\">",
                    "resolved": "\"after\" | \"before\"",
                    "references": {
                        "Exclude": {
                            "location": "global",
                            "id": "global::Exclude"
                        },
                        "TreeViewDropType": {
                            "location": "import",
                            "path": "../tree-view/types",
                            "id": "src/components/tree-view/internal/tree-view/types.ts::TreeViewDropType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the type of drop that is performed over the control."
                },
                "attribute": "type",
                "reflect": false,
                "defaultValue": "\"before\""
            }
        };
    }
}
